




































import Vue from 'vue'

import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { Article } from '@/top/types'
import horizontalScroll from '@/common/horizontalScroll'

export default Vue.extend({
  name: 'TopPageArticle',
  components: {
    BaseImage
  },
  props: {
    articlesData: {
      type: Array as () => Article[],
      required: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.MAGAZINE_CARD
    }
  },
  mounted() {
    horizontalScroll('.tp-Article_Items')
  }
})
